import classnames from 'classnames'

function MinusIcon() {
  return (
    <svg width="11" height="2" viewBox="0 0 11 2" fill="none" aria-hidden="true">
      <path d="M1 1H10" stroke="#17181A" strokeWidth="2" strokeLinecap="round" />
    </svg>
  )
}

function PlusIcon() {
  return (
    <svg width="11" height="11" viewBox="0 0 11 11" fill="none" aria-hidden="true">
      <path d="M5.5 1V10M1 5.5H10" stroke="#17181A" strokeWidth="2" strokeLinecap="round" />
    </svg>
  )
}

export default function NumberStepper({ value, min, max, onChange, className }) {
  return (
    <div className={classnames('flex items-center gap-2 px-[2px] shrink-0', className)}>
      <button
        type="button"
        onClick={() => { if (value > min) onChange(value - 1) }}
        disabled={value <= min}
        className="border border-solid border-on-surface-variant rounded-[4px] w-5 h-[22px] flex items-center justify-center disabled:opacity-[0.38]"
        aria-label="Decrease"
      >
        <MinusIcon />
      </button>
      <span className="text-[18px] font-bold tracking-[0.54px] leading-none text-on-surface min-w-[1ch] text-center">
        {value}
      </span>
      <button
        type="button"
        onClick={() => { if (value < max) onChange(value + 1) }}
        disabled={value >= max}
        className="border border-solid border-on-surface-variant rounded-[4px] w-5 h-[22px] flex items-center justify-center disabled:opacity-[0.38]"
        aria-label="Increase"
      >
        <PlusIcon />
      </button>
    </div>
  )
}
